import { useMemo } from "react";
import { format } from "date-fns";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves vehicle data.
 * @returns - A promise that resolves to the vehicle data.
 */
export const useFetchVehicles = () => {
  const memoizedFetchVehicles = useMemo(
    () => async (assignmentDate, vehicleDivision, duplicate) => {
      const apiDate = format(assignmentDate, "dd-MMM-yyyy");
      return apiGet(
        `/vehicles/${vehicleDivision}/${apiDate}/${duplicate}`,
        "fetching vehicles"
      );
    },
    []
  );

  return memoizedFetchVehicles;
};
